import { render, staticRenderFns } from "./ModalDetalleCts.vue?vue&type=template&id=0bcaa9bd&scoped=true"
import script from "./ModalDetalleCts.vue?vue&type=script&lang=js"
export * from "./ModalDetalleCts.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalleCts.vue?vue&type=style&index=0&id=0bcaa9bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcaa9bd",
  null
  
)

export default component.exports